<template>
  <v-card height="100%">
    <v-card-title>{{ $t('aff.marketingLink') }}</v-card-title>
    <v-card-text>
      <v-layout
        wrap
      >
        <v-flex
          md5
          xs12
        >
          <span>{{ $t('aff.marketingPlan') }}</span>
          <p>
            <b>
              <a
                :href="`https://static.aivia.io/docs/aivia-compensation-plan-${$i18n.locale}.pdf`"
                target="_blank"
              >{{ $t('aff.pdfLink') }}</a>
            </b>
          </p>
        </v-flex>
        <v-flex
          md5
          xs12
        >
          <span v-if="$i18n.locale=='ru'">{{ $t('aff.marketingPresentation') }}</span>
          <p v-if="$i18n.locale=='ru'">
            <b>
              <a
                :href="`https://static.aivia.io/docs/aivia-business-presentation-ru.pdf`"
                target="_blank"
              >{{ $t('aff.pdfLink') }}</a>
            </b>
          </p>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
</style>